import React from "react";

export const Drimbbble = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 12C15.5835 12 12 15.5835 12 20C12 24.4165 15.5835 28 20 28C24.4078 28 28 24.4165 28 20C28 15.5835 24.4078 12 20 12ZM25.2842 15.6876C26.2386 16.8503 26.8113 18.3341 26.8287 19.9392C26.6031 19.8959 24.347 19.436 22.0737 19.7224C22.0217 19.6095 21.9783 19.488 21.9263 19.3666C21.7874 19.0369 21.6313 18.6985 21.475 18.3774C23.9913 17.3536 25.1367 15.8785 25.2842 15.6876ZM20 13.18C21.7353 13.18 23.3232 13.8308 24.5293 14.8981C24.4078 15.0716 23.3752 16.4512 20.9458 17.3622C19.8265 15.3059 18.5857 13.6226 18.3948 13.3623C18.9067 13.2408 19.4447 13.18 20 13.18ZM17.0933 13.8221C17.2755 14.0651 18.4903 15.7571 19.6269 17.7701C16.4338 18.6204 13.6139 18.6031 13.3102 18.6031C13.7527 16.4859 15.1844 14.7245 17.0933 13.8221ZM13.1627 20.0087C13.1627 19.9393 13.1627 19.8698 13.1627 19.8004C13.4577 19.8091 16.7722 19.8525 20.1822 18.8286C20.3818 19.2104 20.564 19.6009 20.7375 19.9913C20.6508 20.0174 20.5553 20.0434 20.4685 20.0694C16.9458 21.206 15.0716 24.3124 14.9154 24.5726C13.8308 23.3666 13.1627 21.7614 13.1627 20.0087ZM20 26.8373C18.4208 26.8373 16.9631 26.2993 15.8091 25.3969C15.9306 25.1453 17.3188 22.4729 21.1713 21.128C21.1887 21.1193 21.1974 21.1193 21.2148 21.1107C22.1779 23.6009 22.5683 25.692 22.6725 26.2907C21.8482 26.6464 20.9458 26.8373 20 26.8373ZM23.8091 25.6659C23.7397 25.2494 23.3752 23.2538 22.4816 20.7983C24.6248 20.4599 26.4989 21.0152 26.7332 21.0933C26.4382 22.9935 25.3449 24.6334 23.8091 25.6659Z"
        fill="#6C3BC7"
        fillOpacity="0.8"
      />
    </svg>
  );
};
